// @catalog F.006
// ProjectionBar — bars grid 30 días (alturas pseudoaleatorias deterministas)
// para visualizar "días realizados vs días del mes" del KPI Proyección cierre.
import { Box } from "@mui/material";

interface ProjectionBarProps {
  daysElapsed: number;
  daysInMonth: number;
  height?: number;
}

export function ProjectionBar(props: ProjectionBarProps): JSX.Element {
  const { daysElapsed, daysInMonth, height = 40 } = props;
  const total = Math.max(1, daysInMonth);
  const elapsed = Math.max(0, Math.min(daysElapsed, total));

  return (
    <Box
      role="img"
      aria-label={`${elapsed} de ${total} días realizados`}
      sx={{
        marginTop: "14px",
        height: `${height}px`,
        display: "flex",
        alignItems: "flex-end",
        gap: "3px",
      }}
    >
      {Array.from({ length: total }, (_, i) => {
        const isRealized = i < elapsed;
        // altura determinista por índice (no random) para evitar re-render flicker.
        const h = 22 + ((i % 5) * 4);
        return (
          <Box
            key={i}
            sx={{
              flex: 1,
              height: `${h}px`,
              backgroundColor: isRealized ? "var(--accent)" : "var(--bg-2)",
              borderRadius: "1px",
            }}
          />
        );
      })}
    </Box>
  );
}
